module.exports = __webpack_public_path__ + "img/Twitch_logo.62e9444f.png";